import React from "react";
import Slider from "react-slick";

// Import css files for react-slick carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../scss/LatestArrival.scss';

const LatestArrivalCarousel = ({ images }) => {

    // carousel next arrow icon on the right position
    const NextArrow = ({ onClick }) => {
        return (
            <div className={`${'btn'} ${'nextBtn'}`} onClick={onClick}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                        d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                </svg>
            </div>
        );
    };
    // carousel previous arrow icon on the left position
    const PrevArrow = ({ onClick }) => {
        return (
            <div className={`${'btn'} ${'prevBtn'}`} onClick={onClick}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-12 w-12"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1"
                        d="M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z"
                    />
                </svg>
            </div>
        );
    };

    // carousel settings
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 1536,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    infinite: true,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                },
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <div id={'latest_arrival_carousel_wrapper'} className="text-center">
            <Slider {...settings}>
                {images.map((image, index) => (
                    <div key={index} className="inline-block img_parent">
                        <img
                            style={{ height: "526px", width: "100%" }}
                            className="object-cover"
                            src={image.img}
                            alt={index}
                        />
                        <div className="overlay">
                            <div className="casual common">MEN's CASUAL</div>
                            <div className="browse common">Browse</div>
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    );
};

export default LatestArrivalCarousel;
